



















/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'TaskCreate',

  components: {
    CardCanvas,
  },

  data() {
    return {
      EEntities,
      projectName: '',
      RouteAssistant,
    }
  },

  computed: {
    projectID(): Number {
      return Number(this.$route.params.id)
    },
  },

  metaInfo: {
    title: 'New Task',
  },

  mounted() {
    // Pre-seed data from the route.params to seed the breadcrumb listing picker title before the API call...
    if (this.$route.params.projectName) {
      this.projectName = this.$route.params.projectName
    }
  },

  methods: {
    handleTaskCreated(taskID: number, createAnother: boolean) {
      if (createAnother) {
        this.scrollToTop()
      } else {
        RouteAssistant.goToTask(
          this.$router,
          this.$route.params.accountId,
          this.projectID,
          taskID,
          this.$permissions,
        )
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
})
